import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('XeroBatchPaymentForm.BillsInformation', {
    batchPaymentBills: 'Xero batch payment bills: {qty}',
    removeAllBills: 'Remove all Bills',
    addBills: 'Add bills',
    total: 'Total',
    emptyText: 'No bills added to the Xero batch payment',
});
